import {
	adminMixin
} from '../admin/mixin'

export const liutiMixin = {
	methods: {
		...adminMixin.methods,
		exportSuggest() {		
			if (this.currentPolicy) {
				this.loadingtext = '正在检测虚拟仓库存...'
				this.customerloading = true
				this.$api.purchase.checkInventoryGoods({
					filtertype: [1,2]
				}).then((res) => {
					this.checkInventoryGoods = res
					if(res.hasQuantity.length){
						this.$message.error('虚拟仓存在商品有实际库存，请选完成调拨')
						this.customerloading = false
						this.transfergoodsBoxData = res.hasQuantity
						this.$nextTick(()=>{
							this.$refs.transfergoodsBox.initList()
							this.$refs.transfergoodsBox.box.alertBox()
						})
						return
					}
					adminMixin.methods.exportSuggest.call(this)
				})
			} else {
				this.$message.error('请选择方案')
			}
		},
		createExcle(sourcedata) {
			// console.log(this.currentPolicy, sourcedata)
			let XLSX = require('xlsx')
			let workbook = XLSX.utils.book_new()
			let initexportdata = this.initexportdata(sourcedata)
			console.log(initexportdata)
			let worksheetsourcedata = XLSX.utils.aoa_to_sheet(this.createexcletabledata(initexportdata))
			
			// console.log(initexportdata)
			
			initexportdata = initexportdata.filter((item) => {
				return item.catagoryuid!="FA4C65963E703302856EF88CAB2FB02B"
			})
			
			if (this.currentPolicy.policyName.includes('备货')) {
				let hasUnderwayCodes = this.checkInventoryGoods.hasUnderway.map((item)=>{
					return item.skuCode
				})
				// console.log(initexportdata,123123)
				let useabledata = initexportdata.filter((item) => {
					return item.supplierid && item.warehouseid
				})
				useabledata = useabledata.filter((item) => {
					return !hasUnderwayCodes.includes(item.code)
				})
				let sheet1data = useabledata.filter((item) => {
					return item.underway_quantity == 0 && item.useable_quantity >= 0
				})

				sheet1data = this.goodsfilter(sheet1data)


				sheet1data = this.addsamesuppliergoods(sheet1data)
				let worksheet1 = XLSX.utils.aoa_to_sheet(this.createexcletabledata(sheet1data))
				XLSX.utils.book_append_sheet(workbook, worksheet1, "筛选1")
			}
			
			XLSX.utils.book_append_sheet(workbook, worksheetsourcedata, "原数据")
			XLSX.writeFile(workbook, this.currentPolicy.name + '.xlsx');
		},
		addsamesuppliergoods(data) {
			return data
		},	
		
		
	}
}